import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {repoAppBuilder} from '@github-ui/repo-app-builder'

export function buildRepositoryProjectTemplatesRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('repositoryProjectTemplatesRoute', {
    path: '/:owner/:repo/projects/templates',
    queries: [],
  })
}

export const repositoryProjectTemplatesRoute = buildRepositoryProjectTemplatesRoute(repoAppBuilder)
